import { useState, useEffect } from "react";
import { useSettingsContext } from "../../../Settings/hooks/useSettingsContext";
import { useTranslation } from "react-i18next";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { 
  MenuItem, Select, FormControl, InputLabel, Box, Grid
} from "@mui/material";
import { default as contractSelectService } from "../services/contractSelect";

const ContractSelectField = ({ input: { onChange, value }, initialValue, label, readOnly, onAvailableItemsUpdate, onSelectUpdate, gas, power, meta, ...rest }) => {

  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const theme = useTheme();
  const breakpointUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const [ availableItems, setAvailableItems ] = useState([]);
  const [ selectedItem, setSelectedItem ] = useState("");
  const [ electricityItems, setElectricityItems ] = useState([]);
  const [ gasItems, setGasItems ] = useState([]);
  const [ contractType, setContractType ] = useState(Settings.features?.displayTypes[0]);
  
  function setDefaultList(electricitatList, gasList) {
    /*
    Dins d'aquesta funció fem les següents verificacions a l'hora de mostrar els contractes

    Hem de mostrar els dos tipus de contractes?
      SI -> La llista de gas té valors i la de llum no?
        SI -> Mostrem la llista de gas
        NO -> Mostrem la llista de llum
      NO -> El tipus per defecte és gas?
        SI -> Mostrem el llista de gas
        NO -> Mostrem el llista de llum
    */

    if (Settings.features?.displayTypes?.length > 1) {
      if (gasList.length >= 1 && electricitatList.length == 0) {
        setAvailableItems(gasList)
        setDefaultValueItem("gas", gasList)
      }
      else{
        setAvailableItems(electricitatList)
        setDefaultValueItem("electricity", electricitatList)
      }
    }
    else{
      if (Settings.features?.displayTypes[0] == 'gas') {
        setAvailableItems(gasList)
        setDefaultValueItem("gas", gasList)
      }
      else {
        setAvailableItems(electricitatList)
        setDefaultValueItem("electricity", electricitatList)
      }
    }
  }

  function setDefaultValueItem(contractType, contractList) {
    setContractType(contractType)

    if (Object.entries(contractList).length > 0){
      setSelectedItem(contractList[0].id)

      const values = {
        contractType: contractType,
        contractId: contractList[0].id
      }
      onChange(values);
    }
  }

  const handleChange = (event) => {
    setSelectedItem(event.target.value);
    const values = {
      contractType: contractType,
      contractId: contractList[0].id
    }
    onChange(values);
  };

  const changeContractType = (event) => {
    const value = event.target.value

    if (value == 'gas'){
      setAvailableItems(gasItems)
      setDefaultValueItem(value, gasItems)
    }
    else {
      setAvailableItems(electricityItems)
      setDefaultValueItem(value, electricityItems)
    }
  }

  useEffect(() => {
    contractSelectService.getContractList()
    .then( response => {
      debugger
      if (response.status === 200) {
        
        const { electricity, gas } = response.data?.result;
  
        setElectricityItems(electricity)
        setGasItems(gas)
        setDefaultList(electricity, gas)
      }
    }).catch((error) => {
      
    }).finally(() => {
      
    })
  }, []);

  return (
    <Box>
      <Grid container spacing={2}>
        {Object.values(Settings.features?.displayTypes).length > 1 && Object.values(electricityItems).length >= 1 &&
          Object.values(gasItems).length >= 1 &&
          <Grid item xs={ breakpointUpMd ? 2 : 12 }>
            <InputLabel shrink htmlFor="">
              {(t('common:text.contact_type_contract')) + "*"}
            </InputLabel>
            <FormControl fullWidth={true}
              disabled={readOnly}
            >
              <Select
                value={contractType}
                onChange={changeContractType}
                style={{textTransform: "capitalize"}}
              >
                <MenuItem value={"electricity"} style={{textTransform: "capitalize"}}>{t('common:content_types.electricity')}</MenuItem>
                <MenuItem value={"gas"} style={{textTransform: "capitalize"}}>{t('common:content_types.gas')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        }

        <Grid item xs={ Object.values(Settings.features?.displayTypes).length > 1 &&
          Object.values(electricityItems).length >= 1 && Object.values(gasItems).length >= 1 &&
          breakpointUpMd ? 10 : 12 }>
          <InputLabel shrink htmlFor="">
            {(t('common:text.contact_contract')) + "*"}
          </InputLabel>
          <FormControl fullWidth={true}
            disabled={readOnly}
          >
            <Select
              value={selectedItem}
              onChange={handleChange}
            >
              {availableItems.map((contract) => {
                  return <MenuItem key={contract.id} value={contract.id}>{contract.name}</MenuItem>
                })
              }
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContractSelectField;
